import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import ContratoService from '../../../../services/contrato-auth';
import Contrato from './cont';


const ListarContratos = () => {

    const [contratos, setContratos] = useState([]);
    const [situacao, setSituacao] = useState(false);
    const [aditivo, setAditivo] = useState(false);
    const [editar, setEditar] = useState(false);
    const [vazio, setVazio] = useState(false);
    const [contrato, setContrato] = useState("");
    const [verContrato, setVerContrato] = useState(false);



    async function fetchContratos() {
        const response = await ContratoService.listar();
        if (response.data.length >= 1) {
            setContratos(response.data)
            setVazio(false)
        } else {
            setContratos([])
            setVazio(true)
        }
    }

    const handleEditar = (contrato) => {
        setContrato(contrato);
        setEditar(true)
    }

    const handleVer = (contrato) => {
        setContrato(contrato);
        setVerContrato(true)
    }

    const handleSituacao = (contrato) => {
        setContrato(contrato);
        setSituacao(true)
    }

    const handleAditivo = (contrato) => {
        setContrato(contrato);
        setAditivo(true)
    }

    const deletar = async (contrato) => {
        if (window.confirm('Tem certeza que deseja deletar o contrato?')) {
            await ContratoService.deletar(contrato)
            alert("Contrato deletado com sucesso!")
            fetchContratos();
        }
    }

    useEffect(() => {
        fetchContratos();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/contratos/editar/${contrato}`} />
        )
    } else if (situacao) {
        return (
            <Navigate to={`/restrito/contratos/situacao/${contrato}`} />
        )
    } else if (aditivo) {
        return (
            <Navigate to={`/restrito/contratos/aditivo/${contrato}`} />
        )
    } else if (verContrato) {
        return (
            <Navigate to={`/restrito/contratos/contrato/${contrato}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setContratos={setContratos}
                        setVazio={setVazio}
                        fetchContratos={fetchContratos}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={4}>
                            {contratos.map((contrato, index) =>
                                <Contrato
                                    fetchContratos={fetchContratos}
                                    contrato={contrato}
                                    key={index}
                                    editar={handleEditar}
                                    ver={handleVer}
                                    aditivo={handleAditivo}
                                    situacao={handleSituacao}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarContratos;